import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { AccordionContext } from '../Accordion';
import styles from '@dtsl/css-accordion/dist/index.module.css';
function AccordionBody(props) {
  const {
    bodyContent,
    itemIdx,
    className = ''
  } = props;
  const {
    visibleAccordionItems
  } = useContext(AccordionContext);
  const accordionBodyContentClasses = classNames({
    [styles['sib-accordion__content']]: true,
    [className]: !!className
  });
  return /*#__PURE__*/React.createElement("div", {
    className: accordionBodyContentClasses,
    "aria-hidden": visibleAccordionItems[itemIdx] ? 'false' : 'true'
  }, bodyContent);
}
AccordionBody.propTypes = {
  bodyContent: PropTypes.node.isRequired,
  itemIdx: PropTypes.number,
  className: PropTypes.string
};
export default AccordionBody;